import { Injectable } from '@angular/core';
import { RestService } from '../../services/core/rest.service';

export const apiUrl = {
    API: 'Master'
}
export const hydrotestConstant = {
    GetDropdownByName: apiUrl.API + '/GetDropdownByName',
    GetSearchDropdowns: apiUrl.API + '/GetSearchDropdowns',
    GetTestPlanDropdowns: apiUrl.API + '/GetTestPlanDropdowns',
    GetSegmentsBySystemCode: apiUrl.API + '/GetSegmentsBySystemCode',
    AddNewSystem: apiUrl.API + '/AddNewSystem',
    AddNewSegment: apiUrl.API + '/AddNewSegment',
    Login: 'login',
}
@Injectable({
    providedIn: 'root'
})
export class HydrotestService {

    constructor(private rest: RestService) { }

    GetSearchDropdowns() { return this.rest.get(hydrotestConstant.GetSearchDropdowns); }
    GetTestPlanDropdowns() { return this.rest.get(hydrotestConstant.GetTestPlanDropdowns); }
    GetSegmentsBySystemCode(systemCode: string) {
        return this.rest.get(hydrotestConstant.GetSegmentsBySystemCode + '/' + systemCode);
    }
    AddNewSystem(systemName: string, modifiedBy: string) {
        return this.rest.post(hydrotestConstant.AddNewSystem, { systemName, modifiedBy });
    }
    AddNewSegment(segmentName: string, parentSystemCode: string, modifiedBy: string) {
        return this.rest.post(hydrotestConstant.AddNewSegment, { segmentName, parentSystemCode, modifiedBy });
    }
    login() { return this.rest.get(hydrotestConstant.Login); }
}
